import { render, staticRenderFns } from "./ShadowSide.vue?vue&type=template&id=3be872c1&"
import script from "./ShadowSide.vue?vue&type=script&lang=js&"
export * from "./ShadowSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports